//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';

import { ITrackableComponent } from '@utils/withTracking';
import { ButtonAnchor } from '@welcome-page/components/onboarding/buttons/ButtonAnchor';
import { useOnboardingButtonStyles } from '@welcome-page/hooks/useOnboardingButtonStyles';

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> &
  ITrackableComponent;

// TODO: PD-257587 - remove this component and replace its uses with one of the standard buttons
export const OnboardingButtonAnchor = (props: Props) => {
  const styles = useOnboardingButtonStyles();
  return <ButtonAnchor styles={styles} {...props} />;
};
